export default {"src":"https://images-cdn-staging.curipod.com/d-f9731459/_next/static/media/feide-logo.aab537d8.ico","height":48,"width":48};